import instance from "./axios";

const getProfile = async (token) => {
	try {
		const response = await instance.get(`api/profile`, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getVehicleInfo = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/vehicle-info`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuotes = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

// Progressive quotes: start a session (returns immediately) then poll its status so cards
// render as each insurer prices instead of blocking on the slowest of ~11. Normalises the
// error shape so callers can branch on `success` (a 404 = old backend → caller falls back
// to the batch getQuotes above).
const startQuoteSession = async (token, payloads) => {
	try {
		const response = await instance.post(
			`api/motor/get-quote/start`,
			payloads,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return (
			error?.response?.data || {
				success: false,
				status_code: error?.response?.status || 0,
				message: error?.message || "Request failed",
				data: null,
			}
		);
	}
};

const getQuoteSessionStatus = async (token, sessionId) => {
	try {
		const response = await instance.get(
			`api/motor/get-quote/status/${sessionId}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return (
			error?.response?.data || {
				success: false,
				status_code: error?.response?.status || 0,
				message: error?.message || "Request failed",
				data: null,
			}
		);
	}
};

const getQuotesGen = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-generali`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuotesRhb = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-rhb`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuotesSompo = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-sompo`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuotesSompoMqt = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-sompo-mqt`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuotesTmim = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-tmim`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuotesLib = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-lib`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuotesEtiqa = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-etiqa`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
}

const getQuotesLonpac = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-lonpac`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
}

const getQuotesTuneProtect = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-tune`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuotesIkhlas = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-ikhlas`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuotesAllianz = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-allianz`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
}

// Pacific & Orient, priced by P&O through the server like every other insurer (VULN-04 residual;
// the add-ons page used to price it in the browser). The server records the quote it returns.
// On this branch the axios instance does not attach the token (main's does), so it is sent here
// like every other helper in this file; without it the call answers 401 "No token provided".
const getQuotesPoi = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-poi`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

// Great Eastern General, priced by Great Eastern through the server, the same way (Ansa-Support#124).
const getQuotesGreatEastern = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-great-eastern`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

// Syarikat Takaful Malaysia, priced by STMB through the server the same way (ansa-backend-new#579).
const getQuotesTakafulMalaysia = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-quote-takaful-malaysia`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

const generateQuotationIkhlas = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/generate-quote-ikhlas`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getRenewal = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/get-renewal-quote`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const generateCV = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/generate-cv`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getMotorAddOns = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/addons`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

const getHealthQuotes = async (token, payloads) => {
	try {
		const response = await instance.post(
			`api/health-insurance/get-health-quote`,
			payloads,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return response.data;
	} catch (error) {
		return error;
	}
};

const getHealthQuotesFilterVariables = async (token) => {
	try {
		const response = await instance.get(
			`api/health-insurance/filter-variables`,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return response.data;
	} catch (error) {
		return error;
	}
};

const createMotorEntry = async (token, payloads) => {
	try {
		const response = await instance.post(
			`api/motor/store`,
			payloads,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return response.data;
	} catch (error) {
		return error;
	}
};

const createHealthEntry = async (token, payloads) => {
	try {
		const response = await instance.post(
			`api/health-insurance/store`,
			payloads,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return response.data;
	} catch (error) {
		return error;
	}
};

const createHealthManualEntry = async (token, payloads) => {
	try {
		const response = await instance.post(
			`api/health-insurance/manual-store`,
			payloads,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return response.data;
	} catch (error) {
		return error;
	}
}; 

const updateHealthEntry = async (token, payloads) => {
	try {
		const response = await instance.post(
			`api/health-insurance/update`,
			payloads,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return response.data;
	} catch (error) {
		return error;
	}
};

const createOrder = async (token, payloads) => {
	try {
		const response = await instance.post(`api/order/store`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const getOrder = async (token, payloads) => {
	try {
		const response = await instance.post(`api/order/details`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const updateOrderDetails = async (token, payloads) => {
	try {
		const response = await instance.post(`api/order/update-details`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const updateOrderStatus = async (token, payloads) => {
	try {
		const response = await instance.post(`api/order/update-status`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const createPolicy = async (token, payloads) => {
	try {
		const response = await instance.post(`api/policy/store`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const viewPolicy = async (token, payloads) => {
	try {
		const response = await instance.post(`api/policy/details`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const submitHelp = async (token, payloads) => {
	try {
		const response = await instance.post(
			`api/help-submission/store`,
			payloads,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return response.data;
	} catch (error) {
		return error;
	}
};

const initiatePayment = async (token, orderNumber) => {
	try {
		const response = await instance.post(
			`api/payment/makepayment`,
			{ orderNumber },
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		console.error("Error in initiatePayment:", error.response?.data || error.message);
		throw error.response?.data || error;
	}
};

// Which gateway the backend wants this order paid through (Ansa-Support#113);
// see utils/gatewayCheckout.js. Authenticated like makepayment. The axios error
// propagates as-is, so the caller can tell a 404 (older backend) from a 409 or a 5xx.
const requestPaymentGateway = async (token, orderNumber) => {
	const response = await instance.post(
		`api/payment/checkout`,
		{ orderNumber },
		{
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		}
	);
	return response.data;
};

const updatePolicy = async (token, payloads) => {
	try {
		const response = await instance.put(`api/policy/update`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		console.error("Error in updatePolicy:", error.response?.data || error.message);
		throw error.response?.data || error;
	}
};

const getMoreQuotes = async (token, payloads) => {
	try {
		const response = await instance.post(
			`api/quote-requests/create`,
			payloads,
			{
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return response.data;
	} catch (error) {
		return error;
	}
};

const getQuoteRequest = async (token, payloads) => {
	try {
		const response = await instance.post(`api/quote-request/details`, payloads, {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const checkQuoteRequestStatus = async (token, payloads) => {
	try {
		const response = await instance.post(`api/quote-request/check-status`, payloads, {
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		});

		return response.data;
	} catch (error) {
		return error;
	}
}

const storeCacheQuote = async (token, payloads) => {
	try {
		const response = await instance.post(`api/quote/store`, payloads, {
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		});

		return response.data;
	} catch (error) {
		return error;
	}
}

const getAppSettings = async () => {
	try {
		const response = await instance.get(`api/app-settings`, {
			headers: {
				"Content-Type": "application/json",
			},
		});

		return response.data;
	} catch (error) {
		return error;
	}
};

const setReminder = async (token, payloads) => {
	try {
		const response = await instance.post(`api/quote/set-reminder`, payloads, {
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		});

		return response.data;
	} catch (error) {
		return error;
	}
}

// "Get reminded to renew your insurance" form (60-day early-renewal window,
// ACS Dashboard BRD 3 July 2026) — persists the reminder + schedules the
// 60/30/14/7/1-day pre-expiry push+email countdown server-side.
const createEarlyRenewalReminder = async (token, payloads) => {
	try {
		const response = await instance.post(`api/motor/early-renewal-reminder`, payloads, {
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		});

		return response.data;
	} catch (error) {
		return error;
	}
}

export {
	getProfile,
	getVehicleInfo,
	getQuotes,
	startQuoteSession,
	getQuoteSessionStatus,
	getQuotesGen,
    getQuotesRhb,
    getQuotesSompo,
	getQuotesSompoMqt,
	getQuotesTmim,
	getQuotesLib,
	getQuotesEtiqa,
	getQuotesLonpac,
	getQuotesTuneProtect,
	getQuotesIkhlas,
	getQuotesAllianz,
	getQuotesPoi,
	getQuotesGreatEastern,
	getQuotesTakafulMalaysia,
	generateQuotationIkhlas,
	getRenewal,
	generateCV,
	getMotorAddOns,
	getHealthQuotes,
	createMotorEntry,
	createHealthEntry,
	createHealthManualEntry,
	updateHealthEntry,
	createOrder,
	getOrder,
	updateOrderDetails,
	updateOrderStatus,
	createPolicy,
	viewPolicy,
	submitHelp,
	getHealthQuotesFilterVariables,
	initiatePayment,
	requestPaymentGateway,
	updatePolicy,
	getMoreQuotes,
	getQuoteRequest,
  	checkQuoteRequestStatus,
	storeCacheQuote,
	setReminder,
	createEarlyRenewalReminder,
	getAppSettings
};
